import React, { useRef, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { QRCodeCanvas } from 'qrcode.react';

/**
 * Componente reutilizable para generar y descargar códigos QR
 * 
 * @param {string} url - URL completa que se codificará en el QR
 * @param {string} filename - Nombre del archivo PNG a descargar (sin extensión)
 * @param {function} onComplete - Callback que se ejecuta después de la descarga
 */
function QRGenerator({ url, filename = 'qr-code', onComplete }) {
  const qrRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerateQR = () => {
    setShowModal(true);
    setIsGenerating(true);

    // Simular un pequeño delay para mostrar el loading
    setTimeout(() => {
      const canvas = qrRef.current?.querySelector('canvas');
      
      if (canvas) {
        // Convertir canvas a blob con alta calidad
        canvas.toBlob((blob) => {
          if (blob) {
            // Crear URL temporal para el blob
            const url = window.URL.createObjectURL(blob);
            
            // Crear elemento <a> temporal para descargar
            const link = document.createElement('a');
            link.href = url;
            link.download = `${filename}.png`;
            document.body.appendChild(link);
            link.click();
            
            // Limpiar
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            setIsGenerating(false);
            
            // Cerrar modal después de un breve delay
            setTimeout(() => {
              setShowModal(false);
              if (onComplete) onComplete();
            }, 500);
          }
        }, 'image/png', 1.0); // Calidad máxima
      }
    }, 300);
  };

  return (
    <>
      <button
        className="btn btn-warning btn-sm"
        onClick={handleGenerateQR}
        title="Descargar código QR"
      >
        <i className="bi bi-qr-code"></i> Descargar QR
      </button>

      <Modal show={showModal} onHide={() => {}} centered backdrop="static" keyboard={false}>
        <Modal.Body className="text-center py-4">
          {isGenerating ? (
            <>
              <Spinner animation="border" variant="warning" className="mb-3" />
              <p className="mb-0">Generando código QR...</p>
            </>
          ) : (
            <>
              <i className="bi bi-check-circle text-success" style={{ fontSize: '3rem' }}></i>
              <p className="mt-3 mb-0">¡Código QR descargado!</p>
            </>
          )}
          
          {/* QR Code oculto, solo para generación */}
          <div ref={qrRef} style={{ display: 'none' }}>
            <QRCodeCanvas
              value={url}
              size={1024} // Tamaño grande para alta calidad (1024x1024px)
              level="H" // Nivel de corrección de errores: L, M, Q, H (H es el más alto)
              includeMargin={true} // Margen blanco alrededor
              bgColor="#FFFFFF" // Fondo blanco
              fgColor="#000000" // QR negro
              imageSettings={{
                excavate: true, // Excavar el área de la imagen si se usa logo
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default QRGenerator;
